import { render, staticRenderFns } from "./BeautySalon.vue?vue&type=template&id=81fafda4&scoped=true"
import script from "./BeautySalon.vue?vue&type=script&lang=js"
export * from "./BeautySalon.vue?vue&type=script&lang=js"
import style0 from "./BeautySalon.vue?vue&type=style&index=0&id=81fafda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fafda4",
  null
  
)

export default component.exports